module.exports = __webpack_public_path__ + "static/media/STATISTICS_NIGHT_MODE.2790e03f.png";